export default __webpack_public_path__ + "static/media/perfil.e3b0fcb5.png";